import { CODES } from '@tdtk/types';
import type { Student } from '../components/digital/common/proctorStepsTypes';

const ESSAY_SECTION_3_SUBTYPE_CD = CODES.AsmtSubtypeCd.SAT_WITH_ESSAY.toString();

export function hasSection3Student(students: Pick<Student, 'asmtSubtypeCd'>[] = []) {
  return students.some((student) => student?.asmtSubtypeCd?.toString() === ESSAY_SECTION_3_SUBTYPE_CD);
}

export function shouldShowSection3(students: Pick<Student, 'asmtSubtypeCd'>[] = []) {
  return hasSection3Student(students);
}

export { ESSAY_SECTION_3_SUBTYPE_CD };
